<template>
  <div class="container container-table">
    <div class="row vertical-10p">
      <template v-for="alert in alerts">
        <b-alert :show="alert.type === 'danger' ? true : alert.dismiss" dismissible :variant="alert.type">
          <h4>
            <i v-if="alert.type === 'success'" class="icon fa fa-check"></i>
            <i class="icon fa fa-ban" v-else></i>
            {{`alert_${alert.type}` | translate($store.getters.language)}}!</h4>
         <span v-if="alert.type === 'danger'">{{'alert_error_1' | translate($store.getters.language)}}<a href="mailto:zalando@schuhe.de">zalando@schuhe.de</a>{{'alert_error_2' | translate($store.getters.language)}} </span>
         <span v-else>{{alert.message}}</span>
        </b-alert>
      </template>
      <div class="container">
        <div class="login-box box">
          <div class="login-logo">
            <router-link to="/">
              <img class="img-responsive center-block" src="/static/img/logo-lg.svg">
            </router-link>
          </div>
          <div class="login-box-body">
            <p class="login-box-msg">
              <span>To download return documents for the desired order, please enter the <span class="text-warning">customer zip code of the delivery address</span> and the <span class="text-warning">Zalando order number</span>.</span>
            </p>
            <div class="form-group has-feedback">
              <input v-validate="'required'" data-vv-as="'Customer zip code'" :disabled="disabled" type="text" name="zipCode" class="form-control" placeholder="Customer zip code" v-model="zipCode">
              <span class="fa fa-home form-control-feedback"></span>
              <span v-show="errors.has('zipCode')" class="small text-danger">{{ errors.first('zipCode') }}</span>
            </div>
            <div class="form-group has-feedback">
              <input v-validate="'required'" data-vv-as="'Zalando order number'" :disabled="disabled" type="text" name="orderNumber" class="form-control" placeholder="Zalando order number" v-model="orderNumber">
              <span class="fa fa-hashtag form-control-feedback"></span>
              <span v-show="errors.has('orderNumber')" class="small text-danger">{{ errors.first('orderNumber') }}</span>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <button :disabled="disabled || errors.any()" class="btn btn-success btn-block" @click="getOrder">
                  <i class="fa fa-download mr-5"></i>Download return documents
                </button>
              </div>
            </div>
            <div class="row mt-10" v-if="downloadLink === ''">
              <div class="col-xs-12">
                <button :disabled="filesLoading || errors.any()" class="btn btn-info btn-block" @click="downloadInvoices">
                  <i :class="[filesLoading ? 'fa fa-spinner fa-spin' : 'fa fa-file-zip-o',  'mr-5']"></i>Download invoices
                </button>
              </div>
            </div>
            <div class="row mt-10" v-else>
              <div class="col-xs-8">
                <a :href="downloadLink" :download="`${orderNumber}-rechnungen`" class="btn btn-primary btn-block">
                  <i class="fa fa-cloud-download mr-5"></i>Download invoices
                </a>
              </div>
              <div class="col-xs-4">
                <button class="btn btn-warning btn-block" @click="clearFields"><i class="fa fa-eraser mr-5"></i>Clear</button>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center mt-10">
                <small class="text-muted"><i class="fa fa-info-circle mr-5"></i>In case of error, please contact <a href="mailto:zalando@schuhe.de">'zalando@schuhe.de'</a></small>
              </div>
            </div>
          </div>
          <div class="overlay" v-show="loading">
            <img class="loading-gif" src="/static/img/blabla.svg"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Api from '@/services/Api'

  export default {
    name: 'Login',
    data () {
      return {
        section: 'Login',
        zipCode: null,
        orderNumber: null,
        ticketNumber: '',
        loading: false,
        response: '',
        alerts: [],
        disabled: false,
        downloadLink: '',
        filesLoading: false
      }
    },
    methods: {
      clearFields () {
        this.zipCode = null
        this.orderNumber = null
        this.downloadLink = ''
      },
      getOrder () {
        this.$validator.validate().then(valid => {
          if (!valid) {
           return true
          }
          let userInput = {orderId: this.orderNumber, orderDeliveryZip: this.zipCode}
          if (this.ticketNumber !== '') {
            userInput.ticket = this.ticketNumber
          }
          this.loading = true
          Api().post(`/v1/tools/zalando?order_id=${this.orderNumber}&order_delivery_zip=${this.zipCode}&type=return`)
            .then(response => {
              this.loading = false
              let index = 1
              response.data.message.forEach(file => {
                const url = window.URL.createObjectURL(this.b64toBlob(file))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `file-${index}.pdf`)
                document.body.appendChild(link)
                link.click()
                index++
              })
              let alert = {type: 'success', dismiss: 4, message: response.data.state}
              this.alerts.push(alert)
            })
            .catch(error => {
              this.loading = false
              let alert = {type: 'danger', dismiss: 4, message: ''}
              this.alerts.push(alert)
            })
        });
      },
      b64toBlob (b64Data, contentType='', sliceSize=512)  {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: contentType});
      },
      downloadInvoices () {
        this.$validator.validate().then(valid => {
          if (!valid) {
            return true
          }
          let userInput = {orderId: this.orderNumber, orderDeliveryZip: this.zipCode}
          if (this.ticketNumber !== '') {
            userInput.ticket = this.ticketNumber
          }
          this.filesLoading = true
          Api().post(`/v1/tools/zalando?order_id=${this.orderNumber}&order_delivery_zip=${this.zipCode}&type=invoice`)
            .then(response => {
              this.downloadLink = response.data.message
              this.filesLoading = false
            })
            .catch(error => {
              this.filesLoading = false
              let alert = {type: 'danger', dismiss: 4, message: ''}
              this.alerts.push(alert)
            })
        });
      }
    },
  }
</script>

<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: absolute;
  }
</style>
